import TranslatableInput from "component/global/translation/TranslatableInput";
import { SharedFieldInputProps } from "./types";

interface TranslatableTextFieldInputProps extends SharedFieldInputProps<string | null> {
    label?: string;
    suggestedKey: string;
    multiline?: boolean;
    onDirtyChange?: (isDirty: boolean) => void;
    onConfirmed?: (key: string) => void | Promise<void>;
    registerFlush?: (flush: () => Promise<boolean>) => () => void;
    translationKey?: string;
    commitMode?: "record";
    defaultPublic?: boolean;
}

export function TranslatableTextFieldInput({
    value,
    onChange,
    error,
    helperText,
    disabled = false,
    label = "Text",
    suggestedKey,
    multiline = false,
    onDirtyChange,
    onConfirmed,
    registerFlush,
    translationKey,
    commitMode,
    defaultPublic = false,
}: TranslatableTextFieldInputProps) {
    return (
        <TranslatableInput
            label={label}
            value={value ?? ""}
            suggestedKey={suggestedKey}
            multiline={multiline}
            helperText={typeof helperText === "string" ? helperText : undefined}
            defaultPublic={defaultPublic}
            disabled={disabled}
            hideLabel
            invalid={error}
            onDirtyChange={onDirtyChange}
            onConfirmed={onConfirmed}
            registerFlush={registerFlush}
            translationKeyOverride={translationKey}
            commitMode={commitMode}
            onChange={(nextValue, displayValue) => onChange(nextValue, displayValue)}
        />
    );
}
